import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    listRestrictions: {
      listStyle: 'none',
      padding: 0,
      margin: '0 0 24px 8px',

      '& li': {
        marginBottom: 5,
        fontFamily: 'Roboto',
        fontSize: 12,
        color: palette.gray,

        '&:before': {
          content: '"•"',
          marginRight: 5,
        },

        '&.valid': {
          color: palette.passwordBlue,

          '&:before': {
            content: '"✓"',
          },
        },
      },
    },
    passwordRules: { fontSize: 14, margin: '0px 0px 5px 8px' },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
    container: {
      justifyContent: 'center',
      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
  });
